import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import {AElement} from "../../../../models/elements/AElement";
import {EElementType, elementsNameKey} from "../../../../models/utils/EElementType";
import {EnergyBox} from "../../../../models/elements/EnergyBox";
import ValidationItem from "../ValidationItem";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    element: AElement,
    label?: string
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 04/07/2022
 * @last_update 04/07/2022
 **/
class Element extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (

            <ValidationItem label={this.props.label ? this.props.label : getTranslation(elementsNameKey[this.props.element.type])}>
                <p>
                    {getTranslation("steps.validation.labels.serial")} : <i>{this.props.element.serialNumber}</i>
                    {
                        this.props.element.type === EElementType.EnergyBox ?
                            (<span><br/>{getTranslation("steps.validation.labels.lora")} : <i>{(this.props.element as EnergyBox).eLoraId}</i></span>)
                            : ""
                    }
                </p>
            </ValidationItem>

        );

    };

}

export default withTranslation()(Element);
